export default __webpack_public_path__ + "static/media/Administrador.1cf17c43.pdf";